/**
 * uni.storage 的类型化封装
 * - 同步 API；序列化/反序列化由内部完成
 * - 业务层只关心 key 和值类型，不感知 stringify/parse
 */

export function setStorage<T>(key: string, value: T): void {
  try {
    uni.setStorageSync(key, JSON.stringify(value))
  } catch (err) {
    console.error('[storage:set]', key, err)
  }
}

export function getStorage<T>(key: string): T | null {
  try {
    const raw = uni.getStorageSync(key)
    if (!raw) return null
    return JSON.parse(raw) as T
  } catch (err) {
    console.error('[storage:get]', key, err)
    return null
  }
}

export function removeStorage(key: string): void {
  try {
    uni.removeStorageSync(key)
  } catch (err) {
    console.error('[storage:remove]', key, err)
  }
}

export function clearStorage(): void {
  try {
    uni.clearStorageSync()
  } catch (err) {
    console.error('[storage:clear]', err)
  }
}
